/* Copyright (c) 2020 Paul Nebel */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';

import PlayerMachine from '../core/utils/player-machine';
import * as styles from '../styles/components.module.css';
// import '../styles/bulma.scss';

class Player extends React.PureComponent {
    static createPlayerMachine(props) {
        let {
            notifyPlayerLoopDurationChanged,
            notifyTransportLoopComplete,
            loopDuration,
            bpm,
        } = props;

        const playerMachine = PlayerMachine;
        playerMachine.bpm = bpm;
        playerMachine.addCallback(notifyTransportLoopComplete, loopDuration);
        notifyPlayerLoopDurationChanged(loopDuration);
        return playerMachine;
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const {
            notifyPlayerLoopDurationChanged,
            variant,
            loopDuration,
            bpm,
            playHeadComplete,
        } = nextProps;

        const {
            loopDuration: prevloopDuration,
            bpm: prevBpm,
            playerMachine,
        } = prevState;

        const newState = {
            ...prevState,
            variant,
            playHeadComplete,
        };

        if (bpm && (bpm !== prevBpm)) {
            playerMachine.bpm = bpm;
        }

        if (loopDuration && (loopDuration !== prevloopDuration)) {
            playerMachine.loopDuration = loopDuration;
            notifyPlayerLoopDurationChanged(loopDuration);
        }

        if (playHeadComplete !== prevState.playHeadComplete) {
            if (prevState.playerMachine.state !== 'stopped') {
                prevState.playerMachine.stop();
                prevState.updateState(prevState.playerMachine);
            }
        }
        
        if (!isEqual(prevState, newState)) {
            return newState;
        } else {
            return null;
        }
    }

    constructor (props, context) {
        super(props, context);

        this.handleStartPauseClicked = this.handleStartPauseClicked.bind(this);
        this.handleStopClicked = this.handleStopClicked.bind(this);
        this.updateState = this.updateState.bind(this);

        const playerMachine = Player.createPlayerMachine(this.props);
        // we want the state to initially be updated after the delay in starting the transport
        playerMachine.addOneOffCallback(this.updateStateAfterTransportDelay.bind(this));
        this.state = {
            ...props,
            playerMachine,
            playerMachinePlaying: false,
            updateState: this.updateState,
        };
    }

    updateStateAfterTransportDelay() {
        const { playerMachine } = this.state;
        this.updateState(playerMachine);
    }

    updateState(playerMachine) {
        this.props.handlePlayerMachineStateChanged(playerMachine.state);
        const newState = { playerMachine };
        if (playerMachine.state == 'stopped') {
            newState.playerMachinePlaying = false;
        }
        this.setState(newState);
    }

    handleStartPauseClicked() {
        const { playerMachine } = this.state;
        // re-instate the lines below to re-activate 'pause' mode
        // if (playerMachine.state === 'started') {
        //     playerMachine.pause();
        // } else {
        //     playerMachine.start();
        // }
        playerMachine.start();
        this.setState({ playerMachinePlaying: true });
    }

    handleStopClicked() {
        const { playerMachine } = this.state;
        playerMachine.stop();
        // we want the state to initially be updated after the delay in starting the transport
        playerMachine.addOneOffCallback(this.updateStateAfterTransportDelay.bind(this));
        this.updateState(playerMachine);
    }

    render() {
        const {
            variant,
            // playerMachine,
            playerMachinePlaying,
        } = this.state;
        return (
            <div className='container'>
                <div className='columns is-mobile is-gapless'>
                    {/* re-instate the lines below to re-activate 'pause' mode
                    <div className='column is-6 has-text-centered'>
                        <button
                            className={ `button ${ variant } is-rounded ${ styles.playerButton }` }
                            onClick={ this.handleStartPauseClicked }
                        >
                            { (playerMachine.state === 'started') ? <i className='fas fa-pause is-size-5 mt-1'></i> : <i className='fas fa-play is-size-5 mt-1'></i> }
                        </button>
                    </div> */}
                    <div className='column is-6 has-text-centered'>
                        <button
                            className={ `button ${ variant } is-rounded ${ styles.playerButton }` }
                            onClick={ this.handleStartPauseClicked }
                            disabled={ playerMachinePlaying }
                        >
                            <i className='fas fa-play is-size-5 mt-1'></i>
                        </button>
                    </div>
                    <div className='column is-6 has-text-centered'>
                        <button
                            className={ `button ${ variant } is-rounded  ${ styles.playerButton }` }
                            onClick={ this.handleStopClicked }
                            disabled={ !playerMachinePlaying }
                        >
                            <i className='fas fa-stop is-size-5 mt-1'></i>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({
    playHeadComplete,
}) => {
    return {
        playHeadComplete,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        handlePlayerMachineStateChanged: (
            playerMachineState,
        ) => dispatch({
            type: `PLAYER_MACHINE_STATE_CHANGED`,
            playerMachineState,
        }),
        notifyTransportLoopComplete: (
            time,
        ) => dispatch({
            type: `TRANSPORT_LOOP_COMPLETE`,
            time,
        }),
        notifyPlayerLoopDurationChanged: (
            playerLoopDuration,
        ) => dispatch({
            type: 'PLAYER_LOOP_DURATION_CHANGED',
            playerLoopDuration,
        }),
    };
};

Player.propTypes = {
    variant: PropTypes.string,
    loopDuration: PropTypes.string,
    volume: PropTypes.number,
    bpm: PropTypes.number,
    handlePlayerMachineStateChanged: PropTypes.func.isRequired,
    notifyTransportLoopComplete: PropTypes.func.isRequired,
    notifyPlayerLoopDurationChanged: PropTypes.func.isRequired,
    playHeadComplete: PropTypes.number,
};

Player.defaultProps = {
    variant: 'is-primary',
    loopDuration: '1m',
    bpm: 120,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Player);
